module.exports = __webpack_public_path__ + "static/media/CKB.e8b26b17.svg";